import { LmIconFilledAccountPeople, LmIconOutlineAccountPeople } from '@mes-ui/lemma/icons';

import { WidgetIconProps } from '../types';

const IconCivilClubsCommon = ({ iconType, ...rest }: WidgetIconProps) =>
  iconType === 'outlined' ? <LmIconOutlineAccountPeople {...rest} /> : <LmIconFilledAccountPeople {...rest} />;

export default IconCivilClubsCommon;
